import React, { useEffect, useState } from 'react';
import { View, Text, Image, ImageStyle, ImageURISource } from 'react-native';
import { Auth, DataStore, Storage } from 'aws-amplify';
import { AppUser } from '../models';
import { WSnackBar } from 'react-native-smart-tip';
import * as AppConst from './AppConst';

/** ================================
*  共通処理
*  ================================*/

// 現在日時
// yyyy-MM-dd形式で取得する
export const getDate = () => {
  const current = new Date();
  const yyyy = current.getFullYear();
  const MM = ('0' + (current.getMonth() + 1)).slice(-2);
  const dd = ('0' + current.getDate()).slice(-2);

  return yyyy + '-' + MM + '-' + dd;
}

// 現在時刻取得
export const getCurrentDateTime = () => {
  const current = new Date();
  const yyyy = current.getFullYear();
  const MM = ('0' + (current.getMonth() + 1)).slice(-2);
  const dd = ('0' + current.getDate()).slice(-2);
  const HH = ('0' + current.getHours()).slice(-2);
  const mm = ('0' + current.getMinutes()).slice(-2);
  const ss = ('0' + current.getSeconds()).slice(-2);

  return yyyy + MM + dd + HH + mm + ss;
}

// 日時フォーマット
// yyyy-MM-ddをDate型に変換する
export const formatToDate = (date: string) => {
  if (date == undefined || date.length < 10) {
    return new Date();
  }
  const tmp = date.substring(0, 10).split('-');
  if (tmp.length != 3) {
    return new Date();
  }
  const yyyy = Number(tmp[0]);
  const MM = Number(tmp[1]) - 1;
  const dd = Number(tmp[2]);
  return new Date(yyyy, MM, dd);
}

// 日時フォーマット
// Date型をyyyy年MM月dd日(aaa)に変換する
export const formatDateAndWeek = (date: Date) => {
  if (date == undefined) {
    return '';
  } else {
    const yyyy = date.getFullYear();
    const MM = ('0' + (date.getMonth() + 1)).slice(-2);
    const dd = ('0' + date.getDate()).slice(-2);
    const dayOfWeek = date.getDay();
    const dayOfWeekStr = ['日', '月', '火', '水', '木', '金', '土'][dayOfWeek];
    return yyyy + '年' + Number(MM) + '月' + Number(dd) + '日' + '(' + dayOfWeekStr + ')';
  }
}

// メールアドレス形式チェック
export const isMailFormat = (mail: string) => {
  const reg = /^[A-Za-z0-9]{1}[A-Za-z0-9_.-]*@{1}[A-Za-z0-9_.-]{1,}.[A-Za-z0-9]{1,}$/;
  if (reg.test(mail)) {
    return true;
  } else {
    return false;
  }
}

// メッセージ表示
export const appMsg = async (msg: string) => {
  WSnackBar.show({
    data: msg,
    textColor: 'white',
    backgroundColor: '#288c66',
    duration: WSnackBar.duration.SHORT,
    position: WSnackBar.position.TOP,
  });
}

// エラーメッセージ表示
export const appAlert = async (msg: string) => {
  WSnackBar.show({
    data: msg,
    textColor: 'white',
    backgroundColor: '#dc143c',
    duration: WSnackBar.duration.LONG,
    position: WSnackBar.position.TOP,
  });
}

// ローディング表示
let loadingFunc: any = null;
export const setLoadingFunc = (func: Function) => {
  loadingFunc = func;
}
export const startLoading = () => {
  loadingFunc(true);
}
export const endLoading = () => {
  loadingFunc(false);
}

// S3Image表示
export const S3Image = ({ imageKey, style, defaultSource }: { imageKey?: string | undefined | null, style?: ImageStyle | undefined, defaultSource?: ImageURISource }) => {
  const [uri, setUri] = useState<string>('');

  useEffect(() => {
    (async () => {
      if (imageKey != undefined && imageKey != null) {
        const tmpUri = await Storage.get(imageKey);
        setUri(tmpUri);
      }
    })();
  }, [imageKey]);

  return (
    <Image resizeMode='contain' source={{ uri: uri }} style={style} defaultSource={defaultSource} />
  );
}

// バッジ表示
export const Badge = ({ count }: { count: number }) => {
  return (
    count > 0 ?
      <View style={AppConst.styles.badgeContainer}>
        <Text style={AppConst.styles.badge}>{count}</Text>
      </View>
      :
      <></>
  );
}

// blob化(S3に画像をアップロードする際に使用する)
export const blobConvert = async (uri: string) => {
  const response = await fetch(uri);
  const blob = await response.blob();
  return blob;
};

// uriから拡張子を取得する
export const getExt = (uri: string) => {
  return uri.toString().slice(uri.indexOf('/') + 1, uri.indexOf(';'));
}

// ログインユーザーのユーザー情報取得
export const getCurrentUser = async () => {
  const currentSession = await Auth.currentSession();
  const { payload } = currentSession.getIdToken();
  const email = payload['email'];

  const appUser = (await DataStore.query(AppUser, c => c.authUserID('eq', email)));
  return appUser.length > 0 ? appUser[0] : undefined;
}
